import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommunicationService } from 'src/modules/base/services/communication.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { LoaderService } from 'src/modules/base/services/loader.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { ModalSize, SmartModalService } from 'src/modules/base/services/smart-modal.service';
import { PopUIEngineComponent } from 'src/modules/base/components/pop-uiengine/pop-uiengine.component';
import { DialogModalSize } from 'src/modules/base/components/dialog/dialog-ref';
import { DialogService } from 'src/modules/base/components/dialog/dialog.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { PopupFormComponent } from 'src/modules/base/components/popupform/popupform.component';
import { PopUpOverGridWithControlsComponent } from 'src/modules/base/components/dynamic-Grid-with-control/pop-up-over-grid-with-controls/pop-up-over-grid-with-controls.component';
import { CommonViewerComponent } from 'src/modules/base/components/viewer/common-viewer/common-viewer.component';
import { RolePermissionService } from 'src/modules/base/shared/services/role-permission.service';
import { CommonService } from 'src/modules/base/services/common.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { PreferenceService } from 'src/modules/base/shared/services/preference.service';
import { PrintService } from 'src/modules/base/shared/services/print.service';
import { AppService } from 'src/modules/base/shared/services/app.service';
import { UtilService } from 'src/modules/base/services/util.service';
import { DynamicPopUpComponent } from 'src/modules/base/components/data-grid/dynamic-pop-up/dynamic-pop-up.component';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { CoversheetService } from './coversheet.service';
declare var jQuery: any;

@Component({
    selector: 'app-cover-sheet',
    templateUrl: './cover-sheet.component.html',
    styleUrls: ['./cover-sheet.component.scss'],
    standalone: false
})
export class CoverSheetComponent implements OnInit, OnDestroy {
  public _currentData: any = {};
  public patientData: {};
  dataGridConfig: any;
  @Input() input: any
  ehr_view: boolean = false;
  secondary_uhid_default: boolean = true;
  subscribekey: Subscription;
  config: any = {};
  isHistoryFromPopup:boolean=false;

  constructor(
    public injector: Injector,
    public router: Router,
    public route: ActivatedRoute,
    public communicationService: CommunicationService,
    public alerts: AlertsService,
    public loader: LoaderService,
    public storageService: StorageService,
    public smartModal: SmartModalService,
    public dialogService: DialogService,
    public baseService: BaseService,
    public rolePermissionService: RolePermissionService,
    public CommonService?: CommonService,
    private printService?: PrintService,
    private appService?: AppService,
    private utilService?: UtilService,
    public preferenceService?: PreferenceService,
    public dialogConfig?: DialogConfig,
    public coversheetService?:CoversheetService
  ) {
    this.communicationService.emitSidebar({ sidebar: false });
  }

  ngOnInit() {
    if (this.dialogConfig?.data && this?.dialogConfig?.['actionType']?.action=="episode_history") {
      this.input=this.dialogConfig
      this.isHistoryFromPopup=true
      //this.firstPickerEvent = true;
    }
    this.subscribekey = this.CommonService.
      documentData.subscribe((data: any) => {
        setTimeout(() => {
          this.emitCustomLink(data)
        })
      });
    this.baseService.setTitle("menu.cover_sheet_episode");
    if (this.input != undefined && typeof (this.input) == 'object') {
      jQuery("#ui_episode_history").css("display", "none");
      this._currentData.screenType = 'episode';
      this._currentData.json = 'episode';
      this.ehr_view = this.input.ehr_view;
    } else {
      this._currentData.screenType = 'cover_sheet';
      this._currentData.json = 'coverSheetAdvance';
      if(this.rolePermissionService != undefined && this.rolePermissionService.checkAccessPermission('ehr_view','coverSheet') == true){
        this.ehr_view = true     
      } else {
        this.ehr_view = false
      }
    }
    this.dataGridConfig = {
      "viewAll": true,
      "hideSearchBox": true,
      "hideResult": false,
      "customButtonsAllowed": false,
      "allowPagination": false,
      "expandTable": false
    };
    
    this.storageService.getSessionStorageData("currentData", (data) => {
      if (data)
        this.patientData = data;
    });
    this.bindGrid();
  }

  ngOnDestroy() {
    if (this.subscribekey)
      this.subscribekey.unsubscribe()
  }

  backResource() {
    jQuery("#ui_episode_history").css("display", "block");
    jQuery("#coverSheet").css("display", "none");
  }

  toggleAutoRefresh() {
    if (this.ehr_view)
      this.ehr_view = false;
    else
      this.ehr_view = true;
    this.bindGrid();
  }

  secondaryUhidBtn() {
    if (this.secondary_uhid_default)
      this.secondary_uhid_default = false;
    else
      this.secondary_uhid_default = true;
    this.bindGrid();
  }

  layoutChange(e) {
    if (!e == true) {
      this._currentData.json = 'coverSheetAdvance'
    } else {
      this._currentData.json = 'coverSheet'
    }
    this.bindGrid();
  }

  buttonAction(event, current_card) {
    let id = "id:" + event.data.id
    this.onClickArrowOpenPopup(current_card, id)
  }

  getPreferenceData(){
        let local:any = localStorage.getItem(this.config.saveKey);
        if(local == null){
          this.config.filter_based = 'all';
        } else{
          try{
            this.config.local = JSON.parse(local);
            this.config.filter_based = this.config.local.filter_based ? this.config.local.filter_based : 'all';
          }catch(err){
            this.config.filter_based = 'all';
          }
        }
        this.HidetoggleVisibility(true, true);
  }

  bindGrid() {
    this.loader.showSpinner();
    this.baseService.getResourceDef(this._currentData.json, (resouceDef) => {
      if (resouceDef) {
        resouceDef.json = this._currentData.json
        this._currentData = resouceDef;
        if (this.input != undefined && typeof (this.input) == 'object') {
          this._currentData.screenType = 'episode';
          this._currentData.json = 'episode';
        } else if (this._currentData.json == 'coverSheet') {
          this._currentData.screenType = 'cover_sheet';
          this._currentData.json = 'coverSheet';
          this.config.saveKey = 'coverSheet_list_config';
          this.getPreferenceData();
        } else {
          this._currentData.screenType = 'cover_sheet';
          this._currentData.json = 'coverSheetAdvance';
          this.config.saveKey = 'coverSheet_list_config';
          this.getPreferenceData();
        }
        if (this._currentData.cards && this._currentData.cards.length > 0) {
          for (let currentCard of this._currentData.cards) {
            currentCard['finalData'] = [];
            currentCard.list['rowClick'] = true;
            let datasource = currentCard.list.APIresource.datasource;
            var data = {};
            if (this._currentData.json == 'episode') {
              data['args'] = this.baseService.buildDyanamicStr(datasource.args, { data: this.input.data })
            } else if (datasource.args && datasource.args.indexOf('!!!') != -1) {
              data['args'] = this.baseService.buildDyanamicStr(datasource.args, { data: this.patientData })
            }
            if (this.secondary_uhid_default) {
              data['args'] = data['args'] + ",secondary_uhid:true"
            } else if (!this.secondary_uhid_default && data['args'].includes('secondary_uhid')) {
              data['args'].replace(",secondary_uhid:true", '');
            }
            if (this._currentData.json == 'episode') {
              data['filter'] = this.baseService.buildDyanamicStr(datasource.filter, { data: this.input.data })
            } else if (datasource.filter && datasource.filter.indexOf('!!!') != -1) {
              data['filter'] = this.baseService.buildDyanamicStr(datasource.filter, { data: this.patientData })
            } else if (datasource.filter) {
              data['filter'] = datasource.filter;
            }
            if (this._currentData.config.page_size && this._currentData.json != 'coverSheetAdvance' && this._currentData.json != 'episode') {
              data['page_size'] = this._currentData.config.page_size;
            }
            if (this.ehr_view)
              data['read_scope_level'] = 'account';
            else if (data['read_scope_level'] != undefined)
              delete data['read_scope_level'];
            currentCard['api_data'] = JSON.parse(JSON.stringify(data));
            if(this._currentData.json == 'coverSheetAdvance' && this.config.filter_based != undefined && this.config.filter_based != 'all' && (currentCard.resource == 'initial_assessment_cover_sheet' || currentCard.resource == 'progress_note_cover_sheet' || currentCard.resource == 'template_assessment_cover_Sheet' || currentCard.resource == 'surgery_note_coversheet' || currentCard.resource == 'package_note_coversheet' || currentCard.resource == 'pac_template_coversheet' || currentCard.resource == 'mini_family_history')){
                data['args'] +=",filter_based:"+this.config.filter_based;
            }
            this.baseService.getData(data ? data : '', "", datasource.resource, datasource.application, datasource.query_id).subscribe(
              (data: any) => {
                if (data.errCode == 0 && data.resource && data.resource.length > 0) {
                  data.resource.forEach(element => {
                    element['currentEncounterId'] = this['patientData']['encounter_id']
                  });
                  if (currentCard.resource == 'op_co_morbidity') {
                    data.resource = [...new Map(data.resource.map((item) => [(item['illness']), item])).values()]
                  }
                  if (currentCard.resource == 'allergy_intolerance_main') {
                    data.resource = [...new Map(data.resource.map((item) => [(item['substance']), item])).values()]
                  }
                  currentCard['finalData'] = data;
                }
                if (this._currentData.json == 'episode'){
                  this.loader.hideSpinner();
                }else if((this._currentData.json == 'coverSheetAdvance' || this._currentData.json == 'coverSheet') && currentCard['resource'] == 'past_medical_history'){
                  this.loader.hideSpinner()
                }
              }, (err) => {
                this.loader.hideSpinner();
                this.alerts.error("error while getting data")
              })
          }
        }
      }
    })
  }

  getOrdersetData(filter_based, filter){
    this.config.filter_based = filter_based;
    if(filter_based)
      this.setPreferenceStorage('filter_based', filter_based);
    for (let currentCard of this._currentData.cards) {
      if (currentCard.resource == 'initial_assessment_cover_sheet' || currentCard.resource == 'progress_note_cover_sheet' || currentCard.resource == 'template_assessment_cover_Sheet' || currentCard.resource == 'surgery_note_coversheet' || currentCard.resource == 'package_note_coversheet' || currentCard.resource == 'pac_template_coversheet' || currentCard.resource == 'mini_family_history') {
        let datasource = currentCard.list.APIresource.datasource;
        let fl_data = {};
        if (currentCard.api_data) {
          fl_data = JSON.parse(JSON.stringify(currentCard.api_data));
          if (filter)
            fl_data['args'] += filter;
        }
        this.baseService.getData(fl_data ? fl_data : '', "", datasource.resource, datasource.application, datasource.query_id).subscribe(
          (data: any) => {
            if (data.errCode == 0 && data.resource) {
              if(data.resource.length > 0)
                data.resource.forEach(element => {
                  element['currentEncounterId'] = this['patientData']['encounter_id']
                });
              currentCard['finalData'] = data;
            }
          }, (err) => {
            this.alerts.error("error while getting data")
          })
      }
    }
  }

  /*************for showing complete data on popup**************/
  onClickArrowOpenPopup(obj, id?) {
    if (obj.displayName) {
      this.baseService.setTitle(obj.displayName);
    }
    this.loader.showSpinner();
    if (this._currentData.json == 'episode') {
      let episodeDatasource = JSON.parse(JSON.stringify(obj.list.APIresource.datasource));
      if (this.secondary_uhid_default) {
        episodeDatasource.args = episodeDatasource.args ? episodeDatasource.args + ',secondary_uhid:true' : 'secondary_uhid:true';
      }
      let popobj = {
        preDefinedFields: { list: { fields: obj.list.fields } },
        datasource: episodeDatasource,
        banner: { key: this.input.data },
        action: 'LIST',
        config: {
          "disable_capability": true,
          "customButtonsAllowed": false,
          "hideSearchBox": true,
          "allowPagination": true,
          "ehr_view_default": true,
          "ehr_view": this.ehr_view
        },
        title: obj.displayName,
        size: DialogModalSize.Lg
      };
      this.dialogService.open(PopupFormComponent, popobj).afterClosed.subscribe(
        response => {
          this.baseService.setTitle("menu.cover_sheet_episode");
          console.log("popup is closed");
        })
    } else {
      let popobj = {
        data: {
          'resource': obj.resource,
          'bannerJson': { 'key': this.patientData, 'datasource': {} }
        },
        config: {
          "disable_capability": true
        },
        title: obj.displayName,
        size: DialogModalSize.Lg
      };
       if(this.config.filter_based != 'all' && (obj.resource == 'initial_assessment_cover_sheet' || obj.resource == 'progress_note_cover_sheet' || obj.resource == 'template_assessment_cover_Sheet' || obj.resource == 'surgery_note_coversheet' || obj.resource == 'package_note_coversheet' || obj.resource == 'pac_template_coversheet' || obj.resource == 'mini_family_history')){
          popobj['data']['args'] = ',filter_based:'+this.config.filter_based;
      }
      if (!this.router?.url?.includes('emrView') && (obj.resource == "allergy_intolerance_main" || obj.resource == "cover_sheet_comorbidity")) {
        delete popobj['config'].disable_capability
      }
      if (this.secondary_uhid_default == true)
        popobj['secondary_uhid_default'] = true
      if (this.ehr_view)
        popobj['read_scope_level'] = 'account';
      if (this._currentData.json == 'coverSheetAdvance' && id != undefined) {
        this.gridclick(obj, popobj, id)
      } else {
        this.dialogService.open(PopUIEngineComponent, popobj).afterClosed.subscribe(
          response => {
            this.baseService.setTitle("menu.cover_sheet_episode");
            console.log("popup is closed");
          })
      }
    }
    this.loader.hideSpinner();
  }

  gridclick(obj, popobj, id) {
    this.baseService.getResourceDef(obj.resource, (resourceDef) => {
      if (resourceDef.list.APIresource.datasource['filter'] != undefined && resourceDef.list.APIresource.datasource['filter'] != null) {
        resourceDef.list.APIresource.datasource['filter'] += "," + id
      } else {
        resourceDef.list.APIresource.datasource['filter'] = id
      }
      popobj.data['resourceDef'] = resourceDef
      this.dialogService.open(PopUIEngineComponent, popobj).afterClosed.subscribe(
        response => {
        })
    })
  }

  GetAmountConfig(op_no: string, uhId: string, serviceRequestId: string, encounter_id: string, callback) {
    this.loader.showSpinner();
    let args = "";
    if (op_no != undefined && op_no != "") {
      args = `op_no:${op_no},uhId:${uhId},serviceRequestId:${serviceRequestId}`;
    } else if (encounter_id != undefined && encounter_id != "") {
      args = `uhId:${uhId},serviceRequestId:${serviceRequestId},encounter_id:${encounter_id}`;
    }
    this.baseService.get("check-due-pending", args, "observation", "diagnostic").subscribe((result: any) => {
      if (result.errCode == -1) {
        callback(result) // true
        //   cb(result.resource)
      } else {
        callback(result)
      }
      this.loader.hideSpinner();
    }, (err) => {
      callback([])
      this.loader.hideSpinner();
    })
  }

  setCumulativeReport(e) {
    let printData = e.item;
    let file = JSON.parse(JSON.stringify(e.field.action_config.file));
    this.GetAmountConfig(printData.op_no, printData.uhId, printData.serviceRequestId, printData.encounter_id, callback => {
      if (callback != undefined && callback && callback.message != 'Success') { // value == true // 
        this.alerts.error("You can not download and view the report as bill is in due stage.");
      } else {
        let data = printData ? [printData] : []
        if (file != undefined && file.file_data.cumulativeInfo != undefined && data != undefined && data.length > 0) {
          if (typeof file.file_data.cumulativeInfo == 'string')
            file.file_data.cumulativeInfo = file.file_data.cumulativeInfo
          let cumulativeInfo = this.baseService.createCumilativeObj({ action: file, items: data });
          file.file_data.cumulativeInfo = btoa(JSON.stringify(cumulativeInfo));
        }
      }
      this.handleFile(file, printData)
    });
  }

  handleFile(action, obj, callback = null) {
    if (action.file_data != undefined) {
      var key = (obj.data != undefined && obj.data[action.key] != undefined) ? obj.data[action.key] : action.file_data.name;
      this.loader.showSpinner();
      var fileObj = JSON.parse(JSON.stringify(action.file_data));
      fileObj.contentType = fileObj.file_type != undefined ? fileObj.file_type : 'pdf';
      fileObj.amount = fileObj.amount != undefined ? fileObj.amount : '';
      fileObj.resource = this.baseService.buildDyanamicStr(fileObj.resource, obj);
      fileObj.application = fileObj.application != undefined ? this.baseService.buildDyanamicStr(fileObj.application, obj) : this.appService.getApplication();
      fileObj.query_id = fileObj.query_id != undefined ? fileObj.query_id : undefined;
      fileObj.args = fileObj.args != undefined ? this.baseService.buildDyanamicStr(fileObj.args, obj) : false;
      fileObj.filter = fileObj.filter != undefined ? this.baseService.buildDyanamicStr(fileObj.filter, obj) : false;

      if (this.appService.getRoles() && this.appService.getRoles().role == "Patient" && obj.facility_id == undefined)
        this.route.data.subscribe((res) => {
          if (res && res.queryParams && res.queryParams.banner && res.queryParams.banner.key && res.queryParams.banner.key.facility_id)
            obj['facility_id'] = res.queryParams.banner.key.facility_id
        })
      if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && obj) {
        fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : obj.facility_id);
      } else if (this.appService.getOrganization() && fileObj.args != undefined && fileObj.args && obj == undefined) {
        fileObj.args = fileObj.args + ",facility_id:" + (this.appService.getOrganization().org_id != "" ? this.appService.getOrganization().org_id : sessionStorage.getItem('facility_id'));
      }
      if (this.appService.getAccountConfigValue('EMRUserPrint') !== undefined)
        // this.prePrint({...action, isUserPrint: true}, obj, fileObj.args, fileObj, callback, key)
        this.printTemplateSettingDetails({ ...action, isUserPrint: true }, obj, fileObj.args, fileObj, callback, key)
      else {
        fileObj.args = fileObj.args?.length ? `${fileObj.args},userPrint:Y` : 'userPrint:Y';
        this.baseService.handleFile(fileObj, async (fileData: any) => {
          this.loader.hideSpinner();
          if (!fileData) {
            this.alerts.error('Server error');
            callback?.(false);
            return;
          }

          if (fileData.type === "application/json") {
            try {
              const response = await fileData.text();
              const parsedResponse = JSON.parse(response);
              if (parsedResponse.errCode === -1 && parsedResponse.message) {
                this.alerts.error(parsedResponse.message);
              }
              console.log(parsedResponse);
            } catch (e) {
              this.alerts.error('API error');
            }
          } else {
            fileObj.key = key;
            this.printService.handleFileReponse(fileObj, action.action, fileData, callback);
          }
        });
      }
    } else {
      console.error("Please provide File Data");
      if (callback) {
        callback(false);
      }
    }
  }

  printTemplateSettingDetails(action: any, obj: any, args: string, fileObj: any, callback?: Function, key?: string, res?: any){
     if (this.appService.getRoles() && this.appService.getRoles().role == "Patient"){
        if (action?.file_data?.args != null) {
            action.file_data.args += `,userPrint:Y`;
        } else if (action?.file_data) {
            action.file_data.args = `userPrint:Y`;
        }  
        this.printFnc(action,obj, args, fileObj, callback, key, res);
    }
     else{ 
      try {
          console.log("Inside PTS Condition diagnostic Report");
          this.utilService.performPreprintAction(
            this.baseService,
            action,
            (res: any) => this.prePrint({...action, isUserPrint: true}, obj, fileObj.args, fileObj, callback, key, res),
            (res: any) => {
              this.printFnc(action,obj, args, fileObj, callback, key, res);
            },
            fileObj.template,
          );
      } catch (err) {
          console.error("Unexpected error in match block:", err);
          this.prePrint({...action, isUserPrint: true}, obj, fileObj.args, fileObj, callback, key)
      }
    }
  }

  private prePrint(action: any, val: any, args: string, fileObj: any, callback?: Function, key?: string, res?: any): void {
    let printWithoutHF = this.appService._currentSessionData?.print_without_h_f;
    console.log("print_without_h_f::::!!!", printWithoutHF);
    if(res && res.print_without_h_f != null){
        printWithoutHF = res.print_without_h_f;
    }
    let defaultPrint = printWithoutHF ? "N" : "Y";
    let isNoOfPrintCopy = (this.appService.getAccountConfigValue('MultiplePrintCopy') !== undefined && action?.isNoOfPrintCopy === true);

    if (action?.isGrid) {
      isNoOfPrintCopy = false;
    }

    const isPrePrintActionVisible = action?.isUserPrint && action?.isPrePrintAction;

    const prePrintForm = {
      title: "",
      form: {
        buttons: {
          Add: [
            {
              label: "Print",
              action: "prePrint"
            }
          ]
        },
        blocks: [
          {
            name: "pre_print",
            class_name: "null",
            layout_type: "no-column",
            order: 1,
            fields: [
              {
                label: "Select Print Header & Footer Type?",
                class_name: "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                order: 2,
                type: "String",
                component: "dropdown",
                name: "userPrint",
                default: defaultPrint,
                datasource: {
                  possible_value: [
                    { id: "Y", value: "With Header & Footer" },
                    { id: "N", value: "Without Header & Footer" }
                  ]
                }
              },
              {
                label: "Select Layout Type?",
                class_name: "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                order: 2,
                type: "String",
                component: "dropdown",
                name: "page_layout",
                default: "portrait",
                visible: isPrePrintActionVisible,
                datasource: {
                  possible_value: [
                    { id: "landscape", value: "Landscape" },
                    { id: "portrait", value: "Portrait" }
                  ]
                }
              },
              {
                label: "No of Print Copy",
                class_name: "kx-control col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 fix",
                order: 3,
                type: "Integer",
                visible: isNoOfPrintCopy,
                component: "numberbox",
                name: "no_of_print_copy",
                default: 2
              }
            ]
          }
        ]
      }
    };

    action.form = prePrintForm.form; // Assign the form structure to the action object

    const modalObj = { action, val };
    this.smartModal.open(DynamicPopUpComponent, modalObj, prePrintForm.title || "", ModalSize.Md)
      .subscribe({
        next: async (res) => {
          if (!res || !res.result) {
            return;
          }

          let updatedArgs = args;
          if (res.result.no_of_print_copy) {
            updatedArgs += `,no_of_print_copy:${res.result.no_of_print_copy}`;
          }

          if (res.result.userPrint) {
            updatedArgs += `,userPrint:${res.result.userPrint}`;
            action.file_data.args = updatedArgs;
            fileObj.args = updatedArgs;
            this.printFnc(action,val, args, fileObj, callback, key, res);
          }
        },
        error: (err) => {
          console.error("Modal closed with error:", err);
        }
      });
  }

  printFnc(action: any, obj: any, args: string, fileObj: any, callback?: Function, key?: string, res?: any) {
    fileObj.args = action.file_data.args;
    this.baseService.handleFile(fileObj, async (fileData: any) => {
      this.loader.hideSpinner();
      if (!fileData) {
        this.alerts.error('Server error');
        callback?.(false);
        return;
      }

      if (fileData.type === "application/json") {
        try {
          const response = await fileData.text();
          const parsedResponse = JSON.parse(response);
          if (parsedResponse.errCode === -1 && parsedResponse.message) {
            this.alerts.error(parsedResponse.message);
          }
          console.log(parsedResponse);
        } catch (e) {
          this.alerts.error('API error');
        }
      } else {
        fileObj.key = key;
        this.printService.handleFileReponse(fileObj, action.action, fileData, callback);
      }
    });
  }

  emitCustomLink(event) {
    var datasourceConfig;
    var obj = {};
    console.log("Event is ", event);
    let config = {};
    if (this.patientData && this.patientData['uhId'] && event.item) {
      event.item.uhId = this.patientData['uhId'];
    }
    if (event.field && event.field.action_config && event.field.action_config.file) {
      this.setCumulativeReport(event);
      return;
    }
    if (event.field && event.field.action_config && event.field.action_config.datasources && Array.isArray(event.field.action_config.datasources) && event.field.action_config.datasources.length > 0) {
      let dt;
      event.field.action_config.datasources.forEach(el => {
        if (el.expression) {
          let item = event.item;
          if (eval(el.expression)) {
            dt = el;
            return;
          }
        }
      });
      if(dt != undefined){
        let args = this.baseService.buildDyanamicStr(dt.args, { data: event.item })
        config = {
          "config": {
            "type": "template",
            "item": event.item,
            "view_config": [
              {
                "type": "pdf",
                "expression": dt.expression,
                "url": dt.url + args
              }
            ],
          },
          "showImageViewer": true,
        }
      }else if(event.field?.action_config?.alert){
        this.alerts.error(event.field.action_config.alert);
      } else{
        this.alerts.error("No Data Found");
      }
      
    }
    else if (event.field && event.field.action_config && event.field.action_config.datasource && event.field.action_config.datasource.url) {
      let args = this.baseService.buildDyanamicStr(event.field.action_config.datasource.args, { data: event.item })
      config = {
        "config": {
          "type": "template",
          "item": event.item,
          "view_config": [
            {
              "type": "pdf",
              "expression": event.field.action_config.datasource.expression,
              "url": event.field.action_config.datasource.url + args
            }
          ],
        },
        "showImageViewer": true,
      }
    } else if (event.field && event.field.action_config && event.field.action_config.datasource && event.field.action_config.datasource.application) {
      let datasource = JSON.parse(JSON.stringify(event.field.action_config.datasource));
      datasource['args'] = this.baseService.buildDyanamicStr(event.field.action_config.datasource.args, { data: event.item });
      datasource['resource'] = this.baseService.buildDyanamicStr(event.field.action_config.datasource.resource, { data: event.item });
      config = {
        "config": {
          "type": "template",
          "item": event.item,
          "view_config": [
            {
              "type": "GRID",
              "datasource": datasource
            }
          ],
        },
        "showImageViewer": true
      }
      datasourceConfig = datasource
      obj['args'] = datasource.args
      if (this.secondary_uhid_default) {
        obj['args'] += "," + "secondary_uhid:true"
      }
      if (this.ehr_view) {
        obj['read_scope_level'] = 'account';
      }
    }
    if (event.field.action_config.getData != undefined && event.field.action_config.getData) {
      config['inPopup'] = true;
      this.baseService.getData(obj, "", datasourceConfig.resource, datasourceConfig.application, datasourceConfig.query_id || datasourceConfig.queryId).subscribe(res => {
        if (res.resource && res.resource.length > 0) {
          if (event.item.labServiceType == "group" && res.resource.length > 1) {
            for (let i = 1; i < res.resource.length; i++) {
              res.resource[0].tests = res.resource[0].tests.concat(res.resource[i].tests)
            }
          }
          config['config']['item'] = res.resource[0].tests
        }
        if (this.ehr_view) {
          config['read_scope_level'] = 'account';
        }
        this.coversheetService.setLinkOpened();
        this.baseService.modalService.dialogService.open(CommonViewerComponent, { size: DialogModalSize.Lg, data: config, title: 'View Document' }).afterClosed.subscribe(data => {
          console.log('data', data)
          this.coversheetService.setLinkClosed();
        }, err => {
          console.log('err', err)
          this.coversheetService.setLinkClosed();
        })
      })
    } else if(config['config']){
      config['inPopup'] = true;
      this.coversheetService.setLinkOpened();
      this.baseService.modalService.dialogService.open(CommonViewerComponent, { size: DialogModalSize.Lg, data: config, title: 'View Document' }).afterClosed.subscribe(data => {
        console.log('data', data)
        this.coversheetService.setLinkClosed();
      }, err => {
        console.log('err', err)
        this.coversheetService.setLinkClosed();
      })
    }
  }

  setPreferenceStorage(key, value, data?){
    let dt: any;
    if(data != undefined){
      dt = data
    }else{
      dt = localStorage.getItem(this.config.saveKey);
      if(dt == null){
        dt = {};
        dt[key] = value;
      } else {
        try{
          dt = JSON.parse(dt);
          dt[key] = value;
        }catch(err){
          dt = {};
          dt[key] = value;
        }
      }
    }
    this.preferenceService.saveTableConfigData(this.config.saveKey, dt, (result) => {
        if(result)
          localStorage.setItem(this.config.saveKey, JSON.stringify(dt));
      });
  }

  toggleVisibility(event, field) {
        field.hidden = !field.hidden;
        const check = event.target.checked;
        if (check === false) {
            field.selected = false;
            this.config.viewAll = false;
        }
        else {
            field.selected = true;
            for (let i = 1; i < this._currentData.cards.length; i++) {
                if (this._currentData.cards[i].selected == true) {
                    this.config.flag = true;
                } else {
                    this.config.flag = false;
                    break;
                }
            }
            if (this.config.flag) {
                this.config.viewAll = true;
            } else {
                this.config.viewAll = false;
            }
        }
        this.setPreferenceStorage(field.displayName, {'hidden':field.hidden});
    }

    HidetoggleVisibility(event, auto = false) {
        const checked = event;
        this.config.fieldOrder = {};
        this._currentData.cards.forEach((item, index) => {
            if(item.displayName == 'Visit details'){
                item.disabled = true;//it will raise an error when column reordering
            } else {
                item.disabled = false;
                if (checked && !auto) {
                    item.selected = true;
                    item.hidden = false;
                }
            }
            if (item.hidden == undefined) {
              if(auto && this.config.local && this.config.local[item.displayName] && this.config.local[item.displayName].hidden != undefined){
                item.hidden = this.config.local[item.displayName].hidden;
                item.selected = !this.config.local[item.displayName].hidden;
                this.config.viewAll = this.config.viewAll == undefined ? (this.config.local[item.displayName].hidden == true ? false : this.config.viewAll) : this.config.viewAll;
              } else{
                item.hidden = false;
                item.selected = true;
              }
            }
        });
        if (auto === false) {
          let abc = {};
            this._currentData.cards.forEach((item, index) => {
                if (item.displayName != '') {
                    if (item.displayName == 'Visit details') {
                        item.disabled = true;
                        item.hidden = false;
                        item.selected = true;
                    } else {
                        item.hidden = !checked;
                        item.selected = checked;
                    }
                    abc[item.displayName] = {"hidden": item.hidden};
                }
            });
            abc['filter_based'] = this.config.filter_based;
            this.setPreferenceStorage(undefined, undefined, abc);
            console.log("whole Preference ",abc)
            this.config.viewAll = false;
        } else {
            if(this.config.viewAll == undefined)
              this.config.viewAll = true;
        }
        if (!auto) {
            // this.saveTableConfig();
        }
    }

    delteConfigData() {
      this.loader.showSpinner();
      var key = this.config.saveKey;
      this.preferenceService.delteConfigData(key, () => {
        this.config.viewAll = true;
        localStorage.setItem(this.config.saveKey, JSON.stringify({}));
          this._currentData.cards.forEach(element => {
          element.hidden = false;
          element.selected = true;
        });
        this.config.filter_based = 'self';
        this.getOrdersetData('self', ',filter_based:self');
        setTimeout(()=>{
          this.getPreferenceData();
          this.loader.hideSpinner();
        })
      });
    }
  
}
